import React, { Component } from 'react'
import { withNamespaces } from "react-i18next";
import { Icon } from "@iconify/react";
import { isDesktop } from 'react-device-detect';
import { connect } from "react-redux";
import MobileHome from './MobileHome';
import { withRouter } from "react-router-dom";

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            
        };
    }

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
        return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    componentDidMount() {
        this.refCodeCheckingAndMobileRedirect();
    }

    refCodeCheckingAndMobileRedirect = () => {
        let referralCode = new URLSearchParams(document.location.search).get(
            "refCode"
        );
        if (referralCode !== null) {
            sessionStorage.setItem("referralCode", referralCode);
        }
 
    };

    render() {
        const { t } = this.props;
        const img = this.imageImport(
            require.context(
                "../../assets/images/home/",
                false,
                /\.(png|jpe?g|svg|webp)$/
            )
        );

        const global = this.imageImport(
            require.context(
                "../../assets/images/",
                false,
                /\.(png|jpe?g|svg|webp)$/
            )
        );

        let imageLanguage = '';
        switch (this.props.currentUser.language_code) {
            case "zh-CN":
                imageLanguage = "-cn"
            break;
            // case "ms":
            //     imageLanguage = "-ms"
            //     break;
            default:
                imageLanguage = ""
            break;
        }

        return (
            <>            
                {isDesktop ? (
                    <>
                        <div className='position-relative'>
                            <img style={{ width: "100%"}} src={img[`home-banner${imageLanguage}.webp`]} alt='home banner'/>         
        
                            <div className='position-absolute' style={{ bottom: "23%", left: "32%"}}>
                                <button className='btn btn-blue' type='button'>
                                    {t('home.learn-now')}
                                </button>
                            </div>
                        </div>      
        
                        <div className='home'>        
                            <section className='section hero'>
                                <div className='x-container'>
                                    <div className='row'>
                                        <div className='col position-relative light-blue-container-shadow'>
                                            <img src={img['45-percent-com.webp']} alt='45% commission'/>
                                            <div className='font-position'>
                                                <h3>{t('home.high-allocation')}</h3>
                                                <p>{t('home.earn-up')}</p>
                                                <h1 className='mt-3'>45%</h1>
                                                <p>{t('home.revenue-share')}</p>
                                            </div>
                                        </div>
        
                                        <div className='col'>
                                            <div className='row g-3'>
                                                <div className='position-relative light-blue-container-shadow'>
                                                    <img src={img['zero-risk.webp']} alt='zero risk'/>                                
                                                    <div className='font-position right'>
                                                        <h3>{t('home.zero-risk')}</h3>
                                                        <h3>{t('home.zero-loss')}</h3>
                                                        <p>{t('home.100-safe')}</p>                              
                                                    </div>
                                                </div>
                                                <div className='position-relative light-blue-container-shadow'>
                                                    <img src={img['join-us.webp']} alt='join us'/>     
                                                    <div className='font-position right'>
                                                        <p>{t('home.become-our')}</p>                              
                                                        <h3>{t('home.affiliate')}</h3>
                                                        <button className='btn btn-blue mt-2'>{t('page-header.join-now')}</button>
                                                    </div>                           
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                     
                                </div>
                            </section>
        
                            <section className='section earnings'>
                                <div className='x-container'>
                                    <div className='d-flex justify-content-between text-center'>                                
                                        <div>
                                            <h3>{t('home.company-net-profit')}</h3>
                                            <h2>MYR 50,000</h2>
                                        </div>
    
                                        <Icon icon="fluent-mdl2:status-circle-error-x"/>
    
                                        <div>
                                            <h3>{t('home.commission-rate')}</h3>
                                            <h2>45%</h2>
                                        </div>
    
                                        <Icon icon="ri:equal-line"/>
    
                                        <div>
                                            <h3>{t('home.earnings')}</h3>
                                            <h2>MYR 22,500</h2>
                                        </div>
                                    </div>                                                                           
                                </div>    
        
                                <img style={{ width: "100%"}} src={img['earnings-bg.webp']} alt='earnings background'/>                                     
                                <p>{t('home.join-x33-affiliate')}</p>        
                            </section>
                        
                            <section className='section stats'>
                                <div className='x-container light-blue-container-shadow'>
                                    <div className='position-relative'>
                                        <img src={img['home-container.webp']} alt='home container'/>
        
                                        <div className='stats-content-container row'>
                                            <div className='stats-content col'>
                                                <img className='no-shadow' src={img['global.svg']} alt='global'/>
                                                <div className='d-flex'>
                                                    <p>20K</p>
                                                    <Icon icon="tdesign:plus"/>
                                                </div>
                                                <h3>{t('home.join-affiliate-agent')}</h3>
                                                <span>{t('home.global')}</span>
                                            </div>
        
                                            <div className='stats-content col'>
                                                <img className='no-shadow' src={img['commission.svg']} alt='commission'/>
                                                <div className='d-flex'>
                                                    <p>13K</p>
                                                    <Icon icon="tdesign:plus"/>
                                                </div>
                                                <h3>{t('home.join-affiliate-agent')}</h3>
                                                <span>{t('home.earn-daily-commission')}</span>
                                            </div>
        
                                            <div className='stats-content col'>
                                                <img className='no-shadow' src={img['country.svg']} alt='country'/>
                                                <div className='d-flex'>
                                                    <p>24</p>
                                                    <Icon icon="tdesign:plus"/>
                                                </div>
                                                <h3>{t('home.country')}</h3>
                                                <span>{t('home.affiliate-country')}</span>
                                            </div>
        
                                            <div className='stats-content col'>
                                                <img className='no-shadow' src={img['daily-commission.svg']} alt='daily-commission'/>
                                                <div className='d-flex'>
                                                    <p>10M</p>
                                                    <Icon icon="tdesign:plus"/>
                                                </div>
                                                <h3>USD</h3>
                                                <span>{t('home.daily-payout')}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>                
        
                        </div>
        
                        <div className='join-us'>
                            <div className='x-container'>
                                <div className='row'>
                                    <div className='position-relative col'>
                                        <img className='asset-1' src={global['club.svg']} alt='club'/>
                                        <img className='asset-2' src={global['dice.svg']} alt='dice'/>
                                        <img className='main-asset' src={global['brand-ambassador.webp']} alt='brand ambassador'/>
                                    </div>
        
                                    <div className='col d-flex flex-column align-items-start justify-content-center px-5'>
                                        <h2>{t('global.join-xingbo')},</h2>
                                        <h2>{t('global.waiting-for')}</h2>
                                        <h1>{t('global.we-promise')}</h1>
                                        <button className='btn btn-blue mt-4'>{t('page-header.join-now')}</button>                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <MobileHome 
                        {...this.state}
                        {...this.props}
                    />
                )}
            </>
        )
    }
}

const mapStateToProps = (state) => {
    
    return {
        currentUser: state.currentUser.data,
    };
};

export default connect(mapStateToProps)(withRouter(withNamespaces("translation")(Home)));

